var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28906 2.1532L5.39062 3.74695L1.28906 5.3407C0.84375 5.48132 0.632812 5.92663 0.796875 6.30163L1.07812 7.00476C1.21875 7.4032 1.71094 7.61413 2.13281 7.47351L9.21094 4.66101C9.51562 4.54382 9.75 4.26257 9.75 3.95788V3.58288C9.75 3.25476 9.51562 2.97351 9.21094 2.85632L2.13281 0.0438222C1.71094 -0.0968028 1.21875 0.114135 1.07812 0.489135L0.796875 1.19226C0.632812 1.5907 0.84375 2.01257 1.28906 2.1532ZM9.9375 8.99695H0.5625C0.234375 8.99695 0 9.25476 0 9.55945V10.6844C0 11.0126 0.234375 11.2469 0.5625 11.2469H9.9375C10.2422 11.2469 10.5 11.0126 10.5 10.6844V9.55945C10.5 9.25476 10.2422 8.99695 9.9375 8.99695Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.06ebf959.svg";
export { ForwardRef as ReactComponent };